module.exports = __webpack_public_path__ + "static/img/privacy-1-3.4a0b99f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-1-3.png
// module id = cua4
// module chunks = 1